import eachDay from 'date-fns/each_day'
import formatDate from 'date-fns/format'
import range from 'lodash/range'
import flatten from 'lodash/flatten'
import compact from 'lodash/compact'
import {JOURNEYS_PER_PAGE} from '.'

export function getOrdersByDays(state, startDate, endDate) {
  const {byDays} = state.aggr
  if (!byDays) return null

  return eachDay(startDate, endDate).map(date => {
    const day = byDays[formatDate(date, 'YYYY-MM-DD')] || {}

    return {
      date,
      orderCount: day.orderCount || 0,
      orderValue: day.orderValue || 0
    }
  })
}

export function getFiltersData(state) {
  const {globalStats, filters} = state.aggr
  if (!globalStats) return null

  // const {timezone} = getCurrentSite(state)
  const {
    maxProducts,
    minProducts,
    productsData,
    maxVisits,
    minVisits,
    visitsData
  } = globalStats

  return {
    productCount: {
      limits: {
        min: minProducts,
        max: maxProducts
      },
      chartData: range(minProducts, maxProducts).map(key => {
        const item = productsData.find(i => i.key === key) || {}
        return {
          'quantity': key,
          'count': item.doc_count || 0
        }
      }),
      xAxisKey: 'quantity',
      dataKey: 'count',
      values: filters.productCount
    },
    sessionCount: {
      limits: {
        min: minVisits,
        max: maxVisits
      },
      chartData: range(minVisits, maxVisits).map(visits => {
        const item = visitsData.find(i => i.key === visits) || {}
        return {
          quantity: visits,
          count: item.doc_count || 0
        }
      }),
      xAxisKey: 'quantity',
      dataKey: 'count',
      values: filters.sessionCount
    },
    customerType: filters.customerType || 'any',
    countries: filters.countries || []
  }
}

export function getAggrChannel(state) {
  const {list} = state.aggr

  if (!list) return null

  return Object.keys(list).map(orderId => {
    const order = list[orderId]
    return order
  }).sort((a, b) => a.date < b.date ? 1 : -1)
}

export function getAggrStats(state) {
  const {stats} = state.aggr
  return stats
}

export function getOrdersPageCount(state) {
  return Math.ceil(state.aggr.listTotal / JOURNEYS_PER_PAGE)
}

export function getOrdersPageCurrent(state) {
  return Math.floor(state.aggr.listSkip / JOURNEYS_PER_PAGE)
}

export function getSelectedGroups(state) {
  const {sessions: {first, second, includes, penultimate, last}} = state.aggr
  const channelGroups = flatten(compact([first, second, includes, penultimate, last]))
  if (!channelGroups.length) return null

  return channelGroups.reduce((acc, {channelGroup, channel}) => {
    return {
      ...acc,
      [channelGroup]: {
        ...(acc[channelGroup] || {}),
        ...(channel ? {[channel]: true} : {})
      }
    }
  }, {})
}

export function getLoadingOrders(state) {
  const {orders} = state
  return orders.listFetching || false
}



// WEBPACK FOOTER //
// ./client/redux/modules/aggr/selectors.js